import * as React from "react";
import { SVGProps } from "react";

const BinanceUsd = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 336 337" {...props}>
    <path
      fill="#f0b90b"
      stroke="#f0b90b"
      d="m168.2.71 41.5 42.5-104.5 104.5-41.5-41.5Zm63 63 41.5 42.5-167.5 167.5-41.5-41.5Zm-189 63 41.5 42.5-41.5 41.5-41.5-41.5Zm252 0 41.5 42.5-167.5 167.5-41.5-41.5Z"
    />
  </svg>
);

export default BinanceUsd;
